import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Table, TableCell as Cell, TableRow} from '@material-ui/core';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';
import TableHeading from "./tableHeading";
import {bidsAgainst} from "../../environment";
import TableCell from './tableCell';
import EditIcon from "@material-ui/icons/Edit";
import EmptyRows from "./emptyRowSpace";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    // width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
    // margin:20,
    padding: 20,
    // background:'red'
  },
  visuallyHidden: {
    // border: 0,
    clip: 'rect(0 0 0 0)',
    // height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

export default function EnhancedTable(props) {

  const [actionRowId, setActionRowId] = useState(null)

  const {data = {}, pagination, vendor = false, tableName, showAddOption = true, smart} = props;
  const {rows = [], column = []} = data;
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const detail = (row, type) => {
    // e.preventDefault();
    console.log(row, type)
    if (type === 'service') {
    } else if (type === 'edit') {
    } else {

    }
    // props.history.push({pathname: `/user/${id}`});
  };
  const bidRowDetail = (row, type) => {
    // e.preventDefault();
    console.log(row, type)

    // props.history.push({pathname: `/user/${id}`});
  };

  return (
    <div className={classes.root}>
      <TableContainer>
        <Table
          className={classes.table}
          stickyHeader aria-label="sticky table"
        >
          <TableHeading
            classes={classes}
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={rows?.length || 0}
            columns={column}
            rows={rows}
          />
          <tr>
            {showAddOption ?
              <td colSpan={Object.keys(column).length + 2} style={{}} className='mt-10 mouse-pointer'
                  onClick={props.addNewHandler}>
                <div className='  mt-10 text-bold mb-10 bg-white pl-10 text-capitalize heading-color'
                     style={{paddingTop: 12, paddingBottom: 12,}}>
                  {tableName === 'vendor' ? 'add new vendor' : tableName === 'supplies' ? 'add new supplies' : tableName === 'harvest' ? 'Add New harvest' :  ''}
                </div>
              </td> :
              <p className=''></p>
            }
          </tr>
          <TableBody className='light-black-color'>
            {stableSort(rows, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                // const isItemSelected = isSelected(row.name);
                const isItemSelected = isSelected(row.id);
                // const id = `enhanced-table-checkbox-${index}`;

                return (

                  <TableRow
                    hover={true}
                    // onClick={(event) => handleClick(event, row.id)}
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.id}
                    selected={isItemSelected}
                  >
                    {/*<TableCell children={<Checkbox*/}
                    {/*  checked={isItemSelected}*/}
                    {/*  inputProps={{'aria-labelledby': row.id}}*/}
                    {/*/>}/>*/}

                    {tableName === 'vendor' ? <>
                        {/*<TableCell id={row.id} scope="row" padding="none">*/}
                        {/*  {row?.id}*/}
                        {/*</TableCell>*/}
                        <TableCell value={row?.id} row={row}/>
                        <TableCell value={row?.vendorName} row={row}/>
                        {/*<TableCell>{row?.vendorName}</TableCell>*/}
                        <TableCell value={row?.coverageArea} row={row}/>
                        {/*<TableCell>{row?.coverageArea}</TableCell>*/}
                      </> :
                      tableName === bidsAgainst ?
                        <>
                          <TableCell value={row?.bidId} row={row}/>
                          <TableCell value={row?.cropName} row={row}/>
                          <TableCell value={row?.bidderFirstName + " " + row?.bidderLastName} row={row}/>
                          <TableCell value={row?.ratePerKg + ' ' + ''} row={row}/>
                          <TableCell value={row?.qty} row={row}/>
                          {/* <TableCell value={row?.totalQuantityBid} row={row}/> */}
                          <TableCell value={row?.businessName} row={row}/>
                          {!smart &&
                          <Cell
                            className="text-capitalize table-more-option-btn-container text-center  border-none">
                            <button
                              className="table-more-option-btn"
                              onClick={() => {
                                setActionRowId(() => {
                                  console.log(row.bidId)
                                  if (actionRowId === row.bidId)
                                    setActionRowId(null)
                                  else
                                    setActionRowId(row.bidId)
                                })
                              }}
                            > ...
                            </button>
                            <div
                              className={actionRowId === row.bidId ? 'button-container' : 'display-none'}>
                              <div className='flex-row-center  edit' onClick={() => bidRowDetail(row, 'Edit')}>
                                <EditIcon titleAccess={'edit'} className={classes.actionIcon} style={{fontSize: 16}}/>
                                <span className='pl-5'> Edit</span>
                              </div>
                            </div>
                          </Cell>
                          }
                          {/* <TableCell value={row?.status} row={row}/> */}

                        </> : tableName === 'supplies' ?
                          <>
                            <TableCell value={row?.businessName} row={row}/>
                            <TableCell value={row?.agriBusinessId?.agriBusinessPoc} row={row}/>
                            <TableCell value={row?.agriBusinessId?.agriBusinessPocContact} row={row}/>
                            <TableCell value={row?.serviceArea} row={row}/>
                            <TableCell value={row?.agriServiceDescription} row={row}/>

                          </> : tableName === 'harvest' ?
                            <>
                              <TableCell value={row?.harvestId} row={row}/>
                              <TableCell value={row?.harvest} row={row}/>
                              <TableCell value={row?.purchasedFrom} row={row}/>
                              <TableCell value={row?.qty + " " + row?.qtyName} row={row}/>
                              <TableCell value={row?.priceSetByVendor} row={row}/>

                            </> : tableName === 'services' &&
                            <>
                              <TableCell value={row?.businessName} row={row}/>
                              <TableCell value={row?.agriBusinessId?.agriBusinessPoc} row={row}/>
                              <TableCell value={row?.agriBusinessId?.agriBusinessPocContact} row={row}/>
                              <TableCell value={row?.serviceArea} row={row}/>
                              <TableCell value={row?.description} row={row}/>
                              <Cell
                                className="text-capitalize table-more-option-btn-container text-center  border-none">
                                <button
                                  className="table-more-option-btn"
                                  onClick={() => {
                                    setActionRowId(() => {
                                      console.log(row.agriServiceId)
                                      if (actionRowId === row.agriServiceId)
                                        setActionRowId(null)
                                      else
                                        setActionRowId(row.agriServiceId)
                                    })
                                  }}
                                > ...
                                </button>
                                <div
                                  className={actionRowId === row.agriServiceId ? 'button-container' : 'display-none'}>
                                  <div className=' edit' onClick={() => detail(row, 'Edit')}>
                                    {/*<EditIcon titleAccess={'edit'} className={classes.actionIcon}/>*/}
                                    <span style={{color: 'green'}}> Accept</span>
                                  </div>
                                  <div className='flex-row-center  contract pt-10'
                                       onClick={() => detail(row, 'contract')}>
                                    {/*<div className=' edit' onClick={(e) => detail(e, row, 'Edit')}>*/}
                                    {/*<AssistantOutlinedIcon titleAccess={'Contract'} className={classes.actionIcon}/>*/}
                                    <span style={{color: '#ff961a'}}> Reject</span>
                                  </div>
                                  <div className='  services pt-10'
                                       onClick={() => detail(row, 'service')}>
                                    {/*<DashboardIcon className={classes.actionIcon} titleAccess={'Services'}/>*/}
                                    <span style={{color: 'red'}}>Delete</span>
                                  </div>
                                </div>
                              </Cell>
                            </>
                    }
                    {/*<TableCell className={'text-center'} value={'...'}/>*/}
                  </TableRow>
                );
              })}
            {/*{emptyRows > 0 && (*/}
            {/*  <EmptyRows emptyRows={1} colSpan={6}/>*/}
            {/*)}*/}

            {rows && rows.length == 0 && (
              <>
                <>No Data Found</>
                <EmptyRows emptyRows={1} colSpan={6}/>
              </>
            )}

          </TableBody>
        </Table>
      </TableContainer>
      {!smart &&
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        // onPageChange={handleChangePage}
        // onRowsPerPageChange={handleChangeRowsPerPage}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
      }
    </div>
  )
    ;
}
